var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { HeadingName } from "../../HeadingName";
import { renderMarketsColumnsFilter } from "../../../../../helpers";
var RenderMarketNames = /** @class */ (function (_super) {
    __extends(RenderMarketNames, _super);
    function RenderMarketNames() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RenderMarketNames.prototype.render = function () {
        var _this = this;
        var trimmed = this.props.queryParams
            ? renderMarketsColumnsFilter(this.props.marketNames, this.props.queryParams)
            : this.props.marketNames;
        return (React.createElement("div", { className: "rj-ev-list__heading__names-wrapper", "data-uat": "div-ev-list-heading-names-wrapper" }, trimmed.map(function (namesArray, index) {
            var classNames = _this.props.marketTemplates[index] ? "rj-ev-list__heading__names--" + _this.props.marketTemplates[index] : "";
            return React.createElement("div", { key: "heading-group-" + index, className: "rj-ev-list__heading__names " + classNames, "data-uat": "div-ev-list-heading-names" }, namesArray.map(function (name, index) {
                return React.createElement(HeadingName, { key: "heading-name-" + index, name: name });
            }));
        })));
    };
    return RenderMarketNames;
}(React.PureComponent));
export { RenderMarketNames };
//# sourceMappingURL=RenderMarketNames.js.map